// import { TextField } from "@mui/material";
import NumberFieldRenderer from "./fields/NumberFieldRenderer";
import DateFieldRenderer from "features/maintenance/components/fields/DateFieldRenderer";
import TextFieldRenderer from "./fields/TextFieldRenderer";
import SelectFieldRenderer from "features/maintenance/components/fields/SelectFieldRenderer";
import PasswordFieldRenderer from "features/maintenance/components/fields/PasswordFieldRenderer";
import LookupField from "components/common/LookupField";
import { Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormHelperText from "@mui/material/FormHelperText";
import DText from "components/common/DText";
import DRadioGroup from "components/common/DRadioGroup";

export default function FieldRenderer(props) {
    const { field, form, setForm, errors, showValidation } = props;

    /*    const handleLookChange = (response) => {
            const sourceDisplayValue = response[field?.lookupField] ?? "";
            const sourceDataValue = response[field?.sourceDataField] ?? "";
            console.log({
                dddd: field?.sourceDataField,
                response,
                sourceDataValue
            });
            if (
                field?.lookUpValidate &&
                !field?.lookUpValidate({ sourceDisplayValue, sourceDataValue })
            ) {
                return;
            }

            const opts = field?.sourceDataField
                ? {
                      [field.name]: sourceDisplayValue,
                      [field.targetDataField]: sourceDataValue
                  }
                : {
                      [field.name]: sourceDisplayValue
                  };
            return setForm((prev) => ({
                ...prev,
                ...opts
            }));
        };*/

    const handleLookChange = (response) => {
        const sourceDisplayValue = response[field?.lookupField] ?? "";

        // Handle nested sourceDataField like "employee.id"
        let sourceDataValue = "";
        if (field?.sourceDataField?.includes(".")) {
            const [parent, child] = field.sourceDataField.split(".");
            sourceDataValue = response[parent]?.[child] ?? "";
        } else {
            sourceDataValue = response[field?.sourceDataField] ?? "";
        }

        if (
            field?.lookUpValidate &&
            !field?.lookUpValidate({ sourceDisplayValue, sourceDataValue })
        ) {
            return;
        }

        const opts = field?.sourceDataField
            ? {
                  [field.name]: sourceDisplayValue,
                  [field.targetDataField]: sourceDataValue
              }
            : {
                  [field.name]: sourceDisplayValue
              };

        console.log({ opts });
        return setForm((prev) => ({
            ...prev,
            ...opts
        }));
    };

    const fieldDisabled =
        field?.disabled ||
        (field?.disabledResolver && field?.disabledResolver(form));

    const nodeLabel = props.noLabel ? { label: "" } : {};
    console.log("FieldRenderer", nodeLabel);

    switch (field.type) {
        case "date":
            return <DateFieldRenderer {...props} disabled={fieldDisabled} />;
        case "number":
            return <NumberFieldRenderer {...props} disabled={fieldDisabled} />;
        case "select":
            return <SelectFieldRenderer {...props} disabled={fieldDisabled} />;
        case "password":
            return (
                <PasswordFieldRenderer
                    {...props}
                    disabled={fieldDisabled}
                    showRequirements={field?.showRequirements}
                />
            );
        case "lookup":
            return (
                <>
                    <LookupField
                        {...props}
                        {...field}
                        {...nodeLabel}
                        disabled={fieldDisabled}
                        resource={field.resource}
                        value={form[field.name] ?? ""}
                        onChange={handleLookChange}
                        error={showValidation && !!errors[field.name]}
                        filterValues={field?.filterValues}
                    />
                </>
            );
        case "bool":
            return (
                <DRadioGroup
                    name={field.name}
                    value={form[field.name]}
                    onChange={(val) =>
                        setForm((prev) => ({ ...prev, [field.name]: val }))
                    }
                    options={field.options} // optional custom labels
                    disabled={fieldDisabled}
                    error={showValidation ? errors[field.name] : null}
                    defaultValue={field.defaultValue}
                />
            );
        case "text":
        default:
            return (
                <TextFieldRenderer
                    {...props}
                    field={{ ...field, ...nodeLabel }}
                    disabled={fieldDisabled}
                />
            );
        /*return (
            <TextField
                fullWidth
                margin="normal"
                label={field.label}
                value={form[field.name] ?? ""}
                required={field.required}
                error={showValidation && !!errors[field.name]}
                helperText={
                    showValidation ? (errors[field.name] ?? "") : ""
                }
                onChange={handleChange}
            />
        );*/
    }
}
